// Generated by CoffeeScript 2.7.0
var Judgement;

export default Judgement = class Judgement {
  static validate(value, raw_judgement) {
    switch (raw_judgement.type) {
      case 'inclusion':
        return _.contains(raw_judgement.in || raw_judgement.within, value);
      case 'range':
        return (_.has(raw_judgement, 'gt') && value > Number(raw_judgement['gt'])) || (_.has(raw_judgement, 'gteq') && value >= Number(raw_judgement['gteq'])) || (_.has(raw_judgement, 'lt') && value < Number(raw_judgement['lt'])) || (_.has(raw_judgement, 'lteq') && value <= Number(raw_judgement['lteq'])) || (_.has(raw_judgement, 'eq') && value === Number(raw_judgement['eq'])) || (_.has(raw_judgement, 'in') && (Number(raw_judgement['in'][0]) <= value && value <= Number(raw_judgement['in'][1]))) || (_.has(raw_judgement, 'within') && (Number(raw_judgement['within'][0]) <= value && value <= Number(raw_judgement['in'][1])));
      default:
        return true;
    }
  }

};
